import { DeepBluex, AlphaDeep, Bluex, Tealx, Redx, Orangex, Napolix, Greenx, Pinkx, Purplex, Greyx } from "./colors.es.js";
const White = {
  main: "#FFFFFF",
  focus: "rgba(255, 255, 255, 0.12)",
  focusVisible: "rgba(255, 255, 255, 0.30)",
  hover: "rgba(255, 255, 255, 0.04)",
  outlinedBorder: "rgba(255, 255, 255, 0.50)",
  selected: "rgba(255, 255, 255, 0.08)"
};
const Common = {
  white: White,
  dark: {
    main: DeepBluex["600"],
    hover: AlphaDeep["4"]
  }
};
const Text = {
  primary: DeepBluex["600"],
  secondary: AlphaDeep["70"],
  disabled: AlphaDeep["38"]
};
const Primary = {
  main: Bluex["400"],
  light: Bluex["50"],
  dark: Bluex["500"],
  contrastText: Common.white.main,
  focus: "rgba(18, 70, 200, 0.12)",
  focusVisible: "rgba(18, 70, 200, 0.10)",
  hover: "rgba(18, 70, 200, 0.04)",
  outlinedBorder: "rgba(18, 70, 200, 0.50)",
  selected: "rgba(18, 70, 200, 0.08)"
};
const Secondary = {
  main: Tealx["400"],
  light: Tealx["0"],
  dark: Tealx["500"],
  contrastText: Text.primary,
  focus: "rgba(0, 187, 140, 0.12)",
  focusVisible: "rgba(0, 187, 140, 0.10)",
  hover: "rgba(0, 187, 140, 0.04)",
  outlinedBorder: "rgba(0, 187, 140, 0.50)",
  selected: "rgba(0, 187, 140, 0.08)"
};
const ErrorToken = {
  main: Redx["400"],
  light: Redx["200"],
  dark: Redx["600"],
  contrastText: Common.white.main,
  focusVisible: "rgba(217, 66, 66, 0.10)",
  hover: "rgba(217, 66, 66, 0.04)",
  outlinedBorder: "rgba(217, 66, 66, 0.50)",
  selected: "rgba(217, 66, 66, 0.08)"
};
const Warning = {
  main: Orangex["400"],
  light: Orangex["100"],
  dark: Orangex["600"],
  contrastText: Common.white.main,
  hover: "rgba(255, 141, 0, 0.04)",
  focusVisible: "rgba(255, 141, 0, 0.10)",
  outlinedBorder: "rgba(255, 141, 0, 0.50)",
  selected: "rgba(255, 141, 0, 0.08)"
};
const Info = {
  main: Napolix["500"],
  light: Napolix["0"],
  dark: Napolix["600"],
  contrastText: Common.white.main,
  focusVisible: "rgba(23, 159, 223, 0.10)",
  hover: "rgba(23, 159, 223, 0.04)",
  outlinedBorder: "rgba(23, 159, 223, 0.50)",
  selected: "rgba(23, 159, 223, 0.08)"
};
const Success = {
  main: Greenx["400"],
  light: Greenx["0"],
  dark: Greenx["500"],
  contrastText: Common.white.main,
  hover: "rgba(34, 136, 95, 0.04)",
  focusVisible: "rgba(34, 136, 95, 0.08)",
  outlinedBorder: "rgba(34, 136, 95, 0.50)",
  selected: "rgba(34, 136, 95, 0.08)"
};
const Action = {
  active: AlphaDeep["56"],
  disabled: AlphaDeep["24"],
  disabledBackground: AlphaDeep["12"],
  focus: AlphaDeep["12"],
  hover: AlphaDeep["4"],
  selected: AlphaDeep["8"]
};
const Tertiary = {
  main: Pinkx["400"],
  light: Pinkx["0"],
  dark: Pinkx["500"],
  contrastText: Common.white.main,
  focus: "rgba(215, 47, 96, 0.12)",
  focusVisible: "rgba(215, 47, 96, 0.10)",
  hover: "rgba(215, 47, 96, 0.04)",
  outlinedBorder: "rgba(215, 47, 96, 0.50)",
  selected: "rgba(215, 47, 96, 0.08)"
};
const Purple = {
  main: Purplex[400],
  light: Purplex[100],
  dark: Purplex[700],
  contrastText: Common.white.main
};
const DeepBlue = {
  main: DeepBluex["300"],
  light: DeepBluex["0"],
  dark: DeepBluex["700"],
  contrastText: Common.white.main
};
const Border = {
  main: AlphaDeep["12"],
  light: AlphaDeep["10"],
  dark: AlphaDeep["30"],
  outlinedBorder: AlphaDeep["50"],
  selected: AlphaDeep["8"],
  focus: AlphaDeep["12"],
  focusVisible: AlphaDeep["30"],
  fillBackdrop: AlphaDeep["50"],
  contrastText: ""
};
const Background = {
  default: Greyx["0"],
  paper: Common.white.main
};
const DIVIDER_COLOR = "#171F361F";
const palette = {
  primary: {
    main: Primary.main,
    light: Primary.light,
    dark: Primary.dark,
    contrastText: Primary.contrastText
  },
  secondary: {
    main: Secondary.main,
    light: Secondary.light,
    dark: Secondary.dark,
    contrastText: Secondary.contrastText
  },
  error: {
    main: ErrorToken.main,
    light: ErrorToken.light,
    dark: ErrorToken.dark,
    contrastText: ErrorToken.contrastText
  },
  warning: {
    main: Warning.main,
    light: Warning.light,
    dark: Warning.dark,
    contrastText: Warning.contrastText
  },
  info: {
    main: Info.main,
    light: Info.light,
    dark: Info.dark,
    contrastText: Info.contrastText
  },
  success: {
    main: Success.main,
    light: Success.light,
    dark: Success.dark,
    contrastText: Success.contrastText
  },
  text: {
    primary: Text.primary,
    secondary: Text.secondary,
    disabled: Text.disabled
  },
  action: {
    active: Action.active,
    hover: Action.hover,
    selected: Action.selected,
    focus: Action.focus,
    disabled: Action.disabled,
    disabledBackground: Action.disabledBackground
  },
  tertiary: {
    main: Tertiary.main,
    light: Tertiary.light,
    dark: Tertiary.dark,
    contrastText: Tertiary.contrastText
  },
  purple: {
    main: Purple.main,
    light: Purple.light,
    dark: Purple.dark,
    contrastText: Purple.contrastText
  },
  deepBlue: {
    main: DeepBlue.main,
    light: DeepBlue.light,
    dark: DeepBlue.dark,
    contrastText: DeepBlue.contrastText
  },
  border: {
    main: Border.main,
    light: Border.light,
    dark: Border.dark,
    contrastText: Border.contrastText
  },
  background: {
    default: Background.default,
    paper: Background.paper
  },
  divider: DIVIDER_COLOR
};
const WorkingTurnsColors = {
  cafOperator: Orangex[400],
  user: Bluex[400],
  finalized: Tealx[400]
};
export {
  Action,
  Background,
  Border,
  Common,
  DIVIDER_COLOR,
  DeepBlue,
  ErrorToken,
  Info,
  Primary,
  Purple,
  Secondary,
  Success,
  Tertiary,
  Text,
  Warning,
  WorkingTurnsColors,
  palette
};
//# sourceMappingURL=palette.es.js.map
